import { pgTable, uuid, timestamp, text, boolean, jsonb, index } from 'drizzle-orm/pg-core';
import { patientProfiles } from '../../patient/models/patientProfiles';
import { ehrIntegrationStatusEnum } from '../enums/ehrIntegrationStatusEnum';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  externalId: uuid('external_id').defaultRandom().notNull().unique(),
  patientId: uuid('patient_id').notNull().references(() => patientProfiles.id, { onDelete: 'cascade' }),
  ehrProvider: text('ehr_provider').notNull(),
  ehrPatientId: text('ehr_patient_id').notNull(), // OpenEMR numeric patient ID (pid)
  ehrPatientUuid: text('ehr_patient_uuid').notNull().unique(), // OpenEMR patient UUID (puuid) - required for some endpoints
  ehrInstanceUrl: text('ehr_instance_url').notNull(),
  isActive: boolean('is_active').default(true).notNull(),
  status: ehrIntegrationStatusEnum('status').default('pending').notNull(),
  connectionMetadata: jsonb('connection_metadata'),
  createdAt: timestamp('created_at', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  updatedAt: timestamp('updated_at', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
};

/**
 * @ignore
 * @internal
 */
export const ehrIntegrations = pgTable(
  'EHRIntegrations',
  schema,
  (table) => [
    index('ehr_integrations_external_id_idx').on(table.externalId),
    index('ehr_integrations_patient_id_idx').on(table.patientId),
    index('ehr_integrations_ehr_provider_idx').on(table.ehrProvider),
    index('ehr_integrations_status_idx').on(table.status),
  ]
);
